<template>
  <!-- Only render the bar while it’s actually showing, and expose ARIA details -->
  <v-progress-linear
    v-model="loadingPercent"
    color="accent"
    :height="4"
    :active="show"
    :query="true"
    role="progressbar"
    aria-label="Page loading progress"
    :aria-valuenow="loadingPercent"
    aria-valuemin="0"
    aria-valuemax="100"
  />
</template>

<script>
let interval = null;

export default {
  name: "PageLoading",
  data() {
    return {
        loadingPercent: 0,
        loadTime: 0,
        show: false
    }
  },
  computed: {
    loaded() {
      return this.loadingPercent + "%";
    }
  },
  watch: {
    loadingPercent(val) {
      if (val >= 100) {
        clearTimeout(interval);
        this.show = false;
      } else {
        this.show = true;
      }
    },
    $route() {
      this.init();
    }
  },
  created() {
    this.init();
  },
  methods: {
    doProgress() {
      let step = this.loadTime / 100;
      interval = setTimeout(() => {
        this.loadingPercent++;
        clearTimeout(interval);
        this.doProgress();
      }, step);
    },
    init() {
      let perfData = window.performance.timing;
      let estimatedTime = Math.abs(
        perfData.loadEventEnd - perfData.navigationStart
      );
      this.loadTime = parseInt((estimatedTime / 1000) % 60) * 100;
      this.doProgress();
    }
  }
};
</script>
